import { gsap } from "gsap";

export default {

  setup() {

    const homebanner = document.getElementById("homepage-banner");

    if(homebanner) {

    gsap.from(".abductee", {
      yPercent: 50,
      duration: 1,
      repeat: -1,
      yoyo : true,
      ease: "power1.inOut"
    })

    gsap.from(".star", {
      autoAlpha: 0,
      duration: 2,
      delay: 1
    })

    gsap.to(".star", {
      scale: 1.75,
      duration: 1,
      transformOrigin: "50% 50%",
      stagger: {
        each: 0.5,
        repeat: -1,
        yoyo: true
      }
    });

    gsap.to(".explosion", {
      autoAlpha: 1,
      duration: 0
    })

    gsap.from(".explosion", {
      scale: 0,
      rotate: 10,
      duration: 1,
      transformOrigin: "70% 100%",
      delay: 2
    });

    gsap.from(".home-banner-logo", {
      autoAlpha: 0,
      duration: 2,
      delay: 3
    });

  }


  gsap.utils.toArray(".card-wrapper").forEach(function(card) {
    gsap.set(card, {
      transformStyle: "preserve-3d",
      transformPerspective: 1000
    });
    const q = gsap.utils.selector(card);
    const front = q(".front");
    const back = q(".back");
    
    gsap.set(back, { rotationY:-180 });
    
    const tl = gsap.timeline({ paused: true })
      .to(front, { duration: 1, rotationY: 180 })
      .to(back, { duration: 1, rotationY: 0, rotationZ: "random(-6, 6)" }, 0)
      .to(card, { z: 50 }, 0)
      .to(card, { z: 0 }, 0.5)
      tl.reverse();
    card.addEventListener("click", function() {
      tl.reversed() ? tl.play() : tl.reverse();
    });
  });





  },
  destroy() {

  },
}